import { useRef } from 'react';
import { useParams } from 'react-router-dom';
import { TransactionTable } from './components/table/table';
import { useTransactions } from './hooks/useTransactions';
import { Box, Typography, FormControlLabel, Checkbox } from '@mui/material';
import { defaultRowsPerPageOptions } from '../../utils/common';
import CustomTablePagination from './components/table/tablePagination';
import Header from './components/header';

export const LedgerTransactionPage = ({ startDate, endDate, includingOpeningBalance }) => {
  const { id } = useParams();
  const accountId = parseInt(id, 10); // Convert to integer
  const PeriodDropDownModalRef = useRef();
  const {
    data,
    rowsperpage,
    includeOpening,
    page,
    openingBalanceSec,
    setfilters,
    filters,
    accountDetails,
    fetchData,
    handleChangePage,
    handleChangeRowsPerPage,
    handleOpeningBalanceChange,
    showLinkedInvoiceVsReceipt,
    handleShowLinkedInvoiceVsReceiptChange,
  } = useTransactions({
    accountId,
    startDate,
    endDate,
    includingOpeningBalance,
  });
  if (isNaN(accountId) || accountId === 0) {
    return <div>404</div>; // Show 404 if not a valid number or if it's 0
  } else {
    return (
      <>
        <Box
          sx={{
            ml: '10px',
            flex: 1,
            display: 'flex',
            alignItems: 'center', // Ensures vertical alignment
          }}
        >
          <Typography
            sx={{
              fontWeight: 600,
              flexGrow: 1, // Ensures it takes up available space
              display: 'flex',
              alignItems: 'center',
              gap: 2,
            }}
          >
            {data.loading && !data.AccountName ? 'Loading' : data.AccountName || <span></span>}
            {data?.AccountTypeFlag ? (
              <FormControlLabel
                control={<Checkbox checked={showLinkedInvoiceVsReceipt} onChange={handleShowLinkedInvoiceVsReceiptChange} />}
                label="Set-Off"
              />
            ) : (
              ''
            )}
          </Typography>
        </Box>
        <Box sx={{ padding: '3px 15px' }}>
          <Header
            PeriodDropDownModalRef={PeriodDropDownModalRef}
            rowsperpage={rowsperpage}
            data={data}
            setfilters={setfilters}
            filters={filters}
            fetchData={fetchData}
            handleOpeningBalanceChange={handleOpeningBalanceChange}
            includeOpening={includeOpening}
          />
        </Box>
        <TransactionTable
          data={data}
          accountDetails={accountDetails}
          page={page}
          rowsperpage={rowsperpage}
          showLinkedInvoiceVsReceipt={showLinkedInvoiceVsReceipt}
          fetchData={fetchData}
          filters={filters}
          openingBalanceSec={openingBalanceSec}
        />

        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <CustomTablePagination
            rowsPerPage={rowsperpage}
            rowsPerPageOptions={defaultRowsPerPageOptions}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            count={data.count}
          />
        </Box>
      </>
    );
  }
};
